import React from 'react';
import moment from 'moment';
import { Box } from '@intech/web-ui';
import { SaldoContribuicoesFaelceEntidade } from '@entidades';

interface IProps {
  saldoAcumulado: SaldoContribuicoesFaelceEntidade | undefined;
}

export const SaldoAcumulado: React.FC<IProps> = ({
  saldoAcumulado
}) => {

  function ToMoney(Valor: number | undefined) {
    if (Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  function renderContribuicao() {
    if (saldoAcumulado !== undefined) {
      return (
        <Box title={"Saldo Acumulado Atualizado"} badgeText={`Referência em ${moment(saldoAcumulado.Referencia, "DD/MM/YYYY").format("DD/MM/YYYY")}`}>
          <h2 className={"text-primary text-center"}>Parabéns! Você já acumulou</h2>
          <h2 className={"text-primary text-center"}>{`R$ ${ToMoney(saldoAcumulado.ContribTotal)}`}</h2>

          <div className={"table-responsive"}>
            <table className={"table table-striped table-sm"}>
              <tbody>
                <tr>
                  <td style={{ "textAlign": "left" }}>
                    <b>
                      {"Subconta Participante"}
                    </b>
                  </td>
                  <td style={{ "textAlign": "right" }}>
                    <b>
                      R$ {ToMoney(saldoAcumulado.ContribParticipante)}
                    </b>
                  </td>
                </tr>

                <tr>
                  <td style={{ "textAlign": "left" }}>
                    <b>
                      {"Subconta Patrocinadora"}
                    </b>
                  </td>
                  <td style={{ "textAlign": "right" }}>
                    <b>
                      R$ {ToMoney(saldoAcumulado.ContribPatrocinadora)}
                    </b>
                  </td>
                </tr>

                <tr>
                  <td style={{ "textAlign": "left" }}>
                    <b>
                      {"Valores Portados"}
                    </b>
                  </td>
                  <td style={{ "textAlign": "right" }}>
                    <b>
                      R$ {ToMoney(saldoAcumulado.ContribPortabilidade)}
                    </b>
                  </td>
                </tr>

                <tr>
                  <td style={{ "textAlign": "left" }}>
                    <b>
                      {"TOTAL"}
                    </b>
                  </td>
                  <td style={{ "textAlign": "right" }}>
                    <b>
                      R$ {ToMoney(saldoAcumulado.ContribTotal)}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Box>
      );
    }

    return null;
  }

  return renderContribuicao();
}